import {
  BomLockedValidation,
  MCode500Validation,
  MultiKVCode510Validation,
  PartDesignAcceptedInTeamcenterValidation,
  Teamcenter2DMCodeValidation,
  TechnicalSpecificationFormatValidation,
  TechnicalSpecificationSequenceValidation,
} from 'src/app/components/header/validation/rules';
import { IValidation, ValidationState } from 'src/app/models';
import { OqcValidation } from '../../components/header/validation/rules/oqc.rule';

/** Gated on the `oqc_validation_enabled` feature flag. */
export const oqcValidationRule: IValidation = {
  description:
    'Validates that the Outgoing Quality Control (OQC) file in Teamcenter contains no warnings or errors without an accompanying comment.',
  id: OqcValidation.name,
  title: 'OQC completed',
  validationState: ValidationState.INITIAL,
  violations: [],
};

export function createValidationRules(): IValidation[] {
  const entities: Record<string, IValidation> = {};

  entities[TechnicalSpecificationFormatValidation.name] = {
    description:
      'Validates that the headline of the TS has the correct format "TS012345-001/V01/A".',
    id: TechnicalSpecificationFormatValidation.name,
    title: 'TS Headline',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[MCode500Validation.name] = {
    description:
      'Validates that M500 codes in the TS have no empty fields (0 counts as empty for "Target value", "Upper limit", "Lower limit", "1. Upper limit", and "1. Lower limit"). For DUPLO elements Md500 codes are checked instead; using a code from the wrong family (M500 on a DUPLO element or Md500 on a regular element) is a failure.',
    id: MCode500Validation.name,
    title: 'M500/Md500 check in TS',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[Teamcenter2DMCodeValidation.name] = {
    description:
      'Validates that all M-codes on the 2D are added in the TS. The values of "Target value", "Upper limit", "Lower limit", "1. Upper limit", and "1. Lower limit" are not checked.',
    id: Teamcenter2DMCodeValidation.name,
    title: 'M-codes on 2D vs. TS',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[TechnicalSpecificationSequenceValidation.name] = {
    description:
      'Validates that the M-codes, F-codes and V-codes are listed in the correct order in the TS.',
    id: TechnicalSpecificationSequenceValidation.name,
    title: 'M/F/V codes in the correct order in TS',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[PartDesignAcceptedInTeamcenterValidation.name] = {
    description: `Validates that the part design has been accepted in Teamcenter (that there is a baseline with status 'LE4_PartDesignAccepted').`,
    id: PartDesignAcceptedInTeamcenterValidation.name,
    title: 'Part design accepted in Teamcenter',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[MultiKVCode510Validation.name] = {
    description:
      'Validates that the correct V-code has been added in the TS for multi component elements: V510 for regular elements and VD510 for DUPLO elements.',
    id: MultiKVCode510Validation.name,
    title: 'V510/VD510 added in TS',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  entities[BomLockedValidation.name] = {
    description: 'Validates that the BOM is locked.',
    id: BomLockedValidation.name,
    title: 'BOM Locked',
    validationState: ValidationState.INITIAL,
    violations: [],
  };

  return Object.values(entities);
}
